import React from 'react'
import { Box } from "@mui/material"

import { useSearchAnalyticsWeekInfo } from "Pages/Main/Page/@hooks"
import { AppAnalyticsCard } from "@components"

export default function SearchAnalyticsCards({ monthSearches, dateRangeSearches, isLoading }) {

	const { weekSearches, isLoadingWeek } = useSearchAnalyticsWeekInfo()
	const datesList = [
		{
			label: "Date Range:",
			actual: dateRangeSearches,
			icon: "calendar-range",
			isLoading: isLoadingWeek,
			iconColor: "colors.green"
		},
		{
			label: "This Week:",
			actual: weekSearches,
			isLoading: isLoadingWeek,
			icon: "calendar-week",
			iconColor: "colors.blue"
		},
		{
			label: "This Month:",
			actual: monthSearches,
			isLoading: isLoading,
			icon: "calendar-days",
			iconColor: "colors.red"
		}
	]

	return <Box
		data-tour-id="tour-activity-cards"
		sx={{
			display: "flex",
			alignItems: "stretch",
			flexDirection: "column",
			p: 0,
			gap: 2
		}}>
		{datesList.map(({ label, actual, icon, iconColor, isLoading }, idx) => {
			return <AppAnalyticsCard
				key={`${idx}-${label}`}
				label={label}
				countUp={actual}
				isLoading={isLoading}
				iconColor={iconColor}
				icon={icon}/>
		})}
	</Box>
}
